const meta = {
  explorer: 'Explore traces',
  analyzer: 'Analyze traces',
  'trace-metrics': 'Use trace metrics',
  examples: 'Examples',
};

export default meta;
